import React, { Component } from 'react';
import { FormGroup, TextInput, DataTableSkeleton, FormLabel, Checkbox, CheckboxSkeleton, TextInputSkeleton, TableContainer, Table, TableBody, TableHead, TableHeader, TableRow, TableCell } from 'carbon-components-react';
import { api } from '../../helpers/api/api';


export class Profile extends Component {
    constructor(props) {
        super(props);


        this.state = {
            profile: [],
            allModules: [],
            modules: [],
            roles: [],
            isLoad: true,
            isLoadModules: true,

        };
        this.divRole = this.divRole.bind(this);
        this.getUserEdit = this.getUserEdit.bind(this);
        this.getModules = this.getModules.bind(this);
    }

    getUserEdit = () => {


        api.getAll('/profile')
            .then(response => {
                this.setState({

                    profile: response.data,
                    modules: response.data.userAppModules,
                    roles: response.data.userRoles,
                    isLoad: false,
                });
            })
    }

    getModules = () => {
        api.getAll("/users/modules")
            .then(response => {
                this.setState({

                    allModules: response.data,
                    isLoadModules: false,
                })
            })
    }



    componentDidMount() {
        this.divRole();
        this.getUserEdit();
        this.getModules();
    }
    filterRole() {
        
        //this.state.roles[0].roleEntity == 1 ? "Worksite" : " Division" 
        if (this.state.roles[0].roleEntity == 1) {
            return "Worksite";
        } else if(this.state.roles[0].roleEntity == 2) {
            //RITM0945977
            // return " Division";
            return " Business Line";
        }
        return "No Entity";
        
    }
    divRole() {
        if (this.state.roles == null || this.state.roles.length == 0) return null;
        const firstrole = this.state.roles[0];
        if (firstrole.role == "Division Manager") firstrole.role = "Consolidator";
        return firstrole ? firstrole.role : "";
    }
    divGeneralSkeleton() {
        return (
            <div>
                <div className=" bx--row " >
                    <div className="bx--col-lg-12 bx--col-md-4">
                        <FormGroup legendText="Email">
                            <div >
                                <TextInputSkeleton />
                            </div>
                        </FormGroup>
                    </div>
                </div>
                <div className=" bx--row " >
                    <div className="bx--col-lg-6 bx--col-md-4">
                        <FormGroup legendText="Name">
                            <div >
                                <TextInputSkeleton />
                            </div>
                        </FormGroup>
                    </div>
                    <div className="bx--col-lg-6 bx--col-md-4">
                        <FormGroup legendText="Surname">
                            <div >
                                <TextInputSkeleton />
                            </div>
                        </FormGroup>
                    </div>
                </div>
            </div>
        )
    }
    divGeneralInfoProfile() {
        return (
            <div>
                <div className=" bx--row " >
                    <div className="bx--col-lg-12 bx--col-md-4">
                        <FormGroup legendText="Email">
                            <div >
                                <TextInput
                                    id="test2"

                                    placeholder={this.state.profile.email}
                                    type="text"
                                    className="bx--text-input disable-text"
                                    defaultValue={this.state.profile.email}
                                    disabled={true}
                                />
                            </div>
                        </FormGroup>
                    </div>
                </div>
                <div className=" bx--row " >
                    <div className="bx--col-lg-6 bx--col-md-4">
                        <FormGroup legendText="Name">
                            <div >
                                <TextInput
                                    id="test2"

                                    placeholder={this.state.profile.name}
                                    type="text"
                                    className="bx--text-input disable-text"
                                    defaultValue={this.state.profile.name}
                                    disabled={true}
                                />
                            </div>
                        </FormGroup>
                    </div>
                    <div className="bx--col-lg-6 bx--col-md-4">
                        <FormGroup legendText="Surname">
                            <div >
                                <TextInput
                                    id="test2"

                                    placeholder={this.state.profile.surname}
                                    type="text"
                                    className="bx--text-input disable-text"
                                    defaultValue={this.state.profile.surname}
                                    disabled={true}
                                />
                            </div>
                        </FormGroup>
                    </div>
                </div>
            </div>
        )
    }
    divModuleSkeleton() {
        return (
            <div className="bx--row">
                <div className="bx--row">
                    <CheckboxSkeleton />
                </div>
            </div>
        )
    }
    divModules() {
        const isCheckedAppModules = (name) => {
            let element = this.state.modules.find(el => el == name);
            return (element != null);
        };
        return (
            <div className="bx--row">


                <div className="bx--row">
                    {this.state.allModules.map(m =>


                        <div className="bx--col-lg-4 bx--col-md-4 bx--checkbox-chadisable--custom" >
                            <Checkbox id={m.id} key={m.id} labelText={m.name} checked={isCheckedAppModules(m.name)} disabled={true} />
                        </div>


                    )}
                </div>
            </div>
        )
    }
    divTableSkeleton() {
        return (
            <div className="title-description-max"
                
            >
                <DataTableSkeleton
                    columnCount={5}
                    compact={false}
                    
                    rowCount={5}
                    zebra={false}
                />
                <br />
            </div>
            )
    }
    divTableRole() {
        return (
            <div className="definition---table">

            {this.state.roles.length > 0 ?
                <TableContainer  >
                    <Table  >
                        <TableHead className="bx--row colorgray" >
                            <TableRow className="bx--col table--profile">


                                Profile -  {this.divRole()}



                            </TableRow>
                        </TableHead>

                        <TableHead className="bx--row colorgray " >
                            <TableRow className="bx--col ">


                                    <span className="bx--table-header-label "> Entity -   {this.filterRole()}</span>



                            </TableRow>
                        </TableHead>


                        <TableBody className="paddingNone">
                            {this.state.roles.map(t => (
                                <TableRow key={t.id} >
                                    <TableCell key="" className="paddingDataTable">
                                        <div className="table--role ">{t.worksite ? t.worksite : t.division}</div>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
                : <p className="notFound">No Entity</p>
            }
            </div>
            )
    }

    render() {

        return (
            <div className="mainContainer">
                <div className="bx--grid content full-width mainContainer " >

                    <div className="bx--row">
                        <div className="bx--col detail--information" >

                            <h3 className="description-page bx--col-max box--title">Profile </h3>


                        </div>
                    </div>

                    {this.state.isLoad ? this.divGeneralSkeleton() : this.divGeneralInfoProfile()}
                    <div >
                        <FormLabel className="label-position">Modules</FormLabel>
                    </div>
                    {this.state.isLoadModules ? this.divModuleSkeleton() : this.divModules()}

                    {this.state.isLoad ? this.divTableSkeleton() : this.divTableRole()}
                </div>
            </div>
        );
    }
}